import { path } from "d3";
export const AxisLeftPath = ({
  yScale,
  innerWidth,
  tickOffset = 4,

  tickValue,
  tickValueMax,
  isSmallScreen,
}) => {
  const linePoints = [
    [0, yScale(tickValue)],
    [innerWidth, yScale(tickValue)],
  ];

  const clipPathLine = path();
  clipPathLine.moveTo(...linePoints[0]);
  linePoints.slice(1).forEach((point) => clipPathLine.lineTo(...point));
  clipPathLine.closePath();

  return (
    <>
      {/* <text
        // className="tick"
        key={tickValue}
        font-family="Poppins, sans-serif"
        style={{ textAnchor: "start" }}
        x={isSmallScreen ? -12 : -25}
        dy=".32em"
        transform={`translate(0,${yScale(tickValue)})`}
        fontSize={isSmallScreen ? 8 : 16}
      >
        {tickValue}
  </text>*/}
      <path
        stroke="#D3D3D3"
        strokeWidth="0.2"
        d={clipPathLine}
        clipPath={tickValue !== tickValueMax && "url(#clip-path)"}
      />
    </>
  );
};
